import React, { useState } from 'react'
import { Form, Row, Col,Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setColorCe, initialState } from '../../store/modules/colorplate';
import langList from '../../utils/languagelist.json'

export default function Colorcell() {
  const {...colorValue}=useSelector((state)=>state.colorplate);
  const {lg}=useSelector((state)=>state.language);
  const dispatch=useDispatch();
  const [selectedColor, setSelectedColor] = useState(colorValue.ce);
  const [checkValue, setCheckValue] = useState(false);

  const handleClick = () => {
    colorValue['ce'] = selectedColor;
    dispatch(setColorCe(colorValue))
    localStorage.setItem('color', JSON.stringify(colorValue));
  }

  const handleChang = (index,value) => {
    if(checkValue) return;
    const newSelectedColor={...selectedColor}
    newSelectedColor['b'+(index+1)]=value;
    setSelectedColor(newSelectedColor)
  }

  const handleCheckChang = (e) => {
    setCheckValue(e.target.checked)
    if(e.target.checked){
      setSelectedColor(initialState.ce)
    };
  }

  return (
    <div>
      <Row xs={3} className="g-1">
        {Array.from({length:9},(_,index)=>(
          <Col className="d-flex justify-content-center" key={index}>
            <Form.Control
              type="color" id={`ColorInput1${index+1}`}
              value={selectedColor['b'+(index+1)]}
              onChange={e=>handleChang(index,e.target.value)}
            />
          </Col>
        ))}
      </Row>
      <Row className="pt-3">
        <Form.Check
          type='checkbox'
          id='cellcheckbox'
          label={langList.colorcell1[lg]}
          checked={checkValue}
          onChange={handleCheckChang}
        />
      </Row>
      <Row className="pt-3">
        <Button variant="outline-primary" size="sm"
          onClick={handleClick}
        >{langList.public7[lg]}</Button>
      </Row>
    </div>
  )
};

